import { useEffect, useRef } from 'react'
import { useLocation } from 'react-router-dom'
import { installFrontendErrorCapture, logEvent } from '../utils/logger'
import { getAppPage, ROUTES } from './navigation'

const PAGE_NAMES = {
  '/': 'Home',
  '/signin': 'Login',
  '/signup': 'Sign Up',
  '/pricing': 'Pricing',
  '/help': 'Help',
  '/privacy-policy': 'Privacy Policy',
  '/onboarding': 'Onboarding',
  '/onboarding-knowledge': 'Knowledge Onboarding',
  '/onboarding-customize-ai': 'Receptionist Onboarding',
  '/phone-numbers': 'Phone Number Setup',
  '/notifications': 'Notifications',
  '/account': 'Account',
  '/updates': 'Updates'
}

export const pageNameForPath = pathname => {
  const exact = PAGE_NAMES[pathname]
  if (exact) return exact
  if (pathname.startsWith('/verify-account')) return 'Verify Account'
  if (pathname.startsWith('/password-reset')) return 'Password Reset'
  if (pathname.startsWith('/feedback')) return 'Feedback'
  if ([ROUTES.overview, ROUTES.receptionist, ROUTES.knowledge, ROUTES.integrations, ROUTES.calls, ROUTES.organization, ROUTES.operations]
    .some(path => pathname.startsWith(path))) return getAppPage(pathname).label
  return 'Unknown'
}

const sectionFromLocation = ({ search, hash }) => {
  if (hash) return hash.replace(/^#/, '').slice(0, 120) || 'anchor'
  const params = new URLSearchParams(search)
  for (const key of ['provider', 'tab', 'section']) {
    if (params.get(key)) return `${key}:${params.get(key).slice(0, 100)}`
  }
  return search ? 'query-change' : ''
}

function FrontendObservability({ axiosClient }) {
  const location = useLocation()
  const previousLocation = useRef(null)

  useEffect(() => installFrontendErrorCapture(axiosClient), [axiosClient])

  useEffect(() => {
    const page = pageNameForPath(location.pathname)
    const previous = previousLocation.current
    if (!previous || previous.pathname !== location.pathname) {
      logEvent({
        event: {
          label: 'PageView',
          data: { page, path: location.pathname, source: 'navigation' }
        }
      })
    } else if (previous.search !== location.search || previous.hash !== location.hash) {
      logEvent({
        event: {
          label: 'SectionView',
          data: {
            page,
            section: sectionFromLocation(location),
            path: location.pathname,
            source: 'navigation'
          }
        }
      })
    }
    previousLocation.current = location
  }, [location])

  return null
}

export default FrontendObservability
